const VISITOR_KEY = "pdf_tools_visitor_id";
// export const API_BASE_URL = "http://localhost:4000";
export const API_BASE_URL = "https://api.pdftools.website";

export function getVisitorId() {
	let id = localStorage.getItem(VISITOR_KEY);
	if (!id) {
		id = crypto.randomUUID();
		localStorage.setItem(VISITOR_KEY, id);
	}
	return id;
}

// Nigeria is UTC+1 (no DST). This is only to reduce duplicate calls.
// Backend still decides the official "day".
function getNigeriaDayKey() {
	const now = new Date();
	const nigeria = new Date(now.getTime() + 60 * 60 * 1000);
	return nigeria.toISOString().slice(0, 10); // YYYY-MM-DD
}

export async function logDailyHomepageVisit() {
	const visitorId = getVisitorId();

	const dayKey = getNigeriaDayKey();
	const storageKey = `pdf_tools_home_logged_${dayKey}`;

	// avoid calling backend multiple times in same day
	if (localStorage.getItem(storageKey)) return;

	const payload = {
		visitorId,
		page: "/",
		referrer: document.referrer || null,
		timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
		language: navigator.language,
	};

	const res = await fetch(`${API_BASE_URL}/api/analytics/daily-visit`, {
		method: "POST",
		headers: { "Content-Type": "application/json" },
		body: JSON.stringify(payload),
	});

	if (res.ok) {
		localStorage.setItem(storageKey, "1");
	}
}

export async function logOperationSuccess(data) {
	const visitorId = getVisitorId();

	await fetch(`${API_BASE_URL}/api/analytics/operation`, {
		method: "POST",
		headers: { "Content-Type": "application/json" },
		body: JSON.stringify({
			visitorId,
			success: true,
			...data, // operation, page, fileCount, totalBytes, outputType, durationMs
		}),
	});
}
